import { DataSource, RemoteSource } from '@components-common/types';
import { UseMutateFunction, useMutation, useQueryClient } from "react-query";
import { useHttpClient, useNotifications } from "../../hooks";
import {
  createdErrorNotification,
  createdSuccessNotification,
  deleteErrorNotification,
  deleteSuccessNotification
} from "@dirootie-web/web-components-types";
import { useApiUrlBuilder } from "./use-api.hook";
import { useMemo } from "react";

export const useApiPost = <T>() => {
  const build = useApiUrlBuilder();
  const httpClient = useHttpClient();
  return useMemo(() => async (source: RemoteSource, payload:T) => {
      const url = build(source.url, source.urlParams);
      const res = await httpClient.post<T>(url, payload);
    return res.body;
    }, [build,httpClient])
}

export const usePost = () => {
  const queryClient = useQueryClient();
  const post = useApiPost<any>(); // Adjust the type if needed
  const userNotificationService = useNotifications();

  return useMutation(
    ({ source, payload }: { source: DataSource, payload: any }) => post(source as RemoteSource, payload),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('source'); // Adjust the query key as needed
        userNotificationService.success(createdSuccessNotification);
      },
      onError: (err: any) => {
        userNotificationService.error(createdErrorNotification(err));
      },
    }
  ).mutateAsync;
};
